<template>
  <b-container fluid>
    <page-header title="Permission List">
      <template #actions>
        <button-options
          :access="'master_permission'"
          :hideAdd="false"
          :hideDetail="true"
          :isRefreshEnabled="true"
          :isRefreshed="isRefreshed"
          @onAddItemClicked="openAddForm"
          @onRefreshed="getData('Refreshed')"/>
      </template>
    </page-header>
    <div class="iq-card">
      <div class="iq-card-body">
        <b-row class="mb-3">
          <b-col md="4" sm="6">
            <input class="form-control" type="text" placeholder="Search by permission name" v-model="searchTerm"
              @input="debouncedSearch">
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <permission-list
              :access="'master_permission'"
              :data="data"
              :loading="isLoading"
              :pagination="pagination"
              @onActionDelete="openDelete"
              @onActionEdit="openEdit"
              @onPageChanged="onPageChanged"
              @update="onUpdated"/>
          </b-col>
        </b-row>
      </div>
      <b-modal
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        v-model="displayForm">
        <permission-form
          :data="currentPermission"
          :errors="errors"
          :isSubmit="isSubmit"
          @onSubmitClicked="onSubmitClicked"
          @onCancelAddClicked="onCancel" />
      </b-modal>
      <b-modal
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        v-model="displayDeletion">
        <delete-item
          :isSubmit="isSubmit"
          @onCancelDeletion="displayDeletion = false"
          @onConfirmDeletion="onConfirmDeletion"/>
      </b-modal>
    </div>
  </b-container>
</template>

<script>

import ButtonOptions from '@/components/directives/button-options';
import DeleteItem from '@/components/directives/delete-item';
import PermissionForm from '@/components/permission/Form';
import PermissionList from '@/components/permission/List';
import PermissionSvc from '@/services/PermissionSvc';

import requestBuilder from '@/util/master/request.builder';

export default {
  name: 'Permission',
  components: {
    DeleteItem,
    PermissionForm,
    PermissionList,
    ButtonOptions,
  },
  data() {
    return {
      currentPermission: {},
      data: [],
      displayDeletion: false,
      displayForm: false,
      errors: {},
      filter: {
        prmsName: null,
      },
      isLoading: false,
      isRefreshed: false,
      isSubmit: false,
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 0,
      },
      searchTerm: '',
    };
  },
  methods: {
    async deleteData(notification, data) {
      this.isSubmit = true;
      try {
        const resp = await PermissionSvc.deletePermission(data.prmsId);
        if (resp.data.status.error === 0) {
          await this.$toast.success(notification);
          this.displayDeletion = await false;
          this.pagination.current = 1;
          this.getData();
        } else {
          this.$toast.error(resp.data.status.message);
        }
      } catch (e) {
        this.$toast.error(e.message);
      } finally {
        this.isSubmit = false;
      }
    },
    async getData(notification) {
      this.isLoading = true;
      this.isRefreshed = true;
      try {
        const permissionResponse = await PermissionSvc.getPermissions({
          ...requestBuilder.buildFilters(this.pagination, this.filter),
        });
        this.data = permissionResponse.data.data || [];
        this.pagination.totalSize = permissionResponse.data.pagination?.totalData || 0;
        if (notification) {
          this.$toast.success(notification);
        }
      } catch (e) {
        console.error('get data error : ', e);
      } finally {
        this.isLoading = false;
        this.isRefreshed = false;
      }
    },
    onCancel() {
      this.currentPermission = {};
      this.displayForm = false;
    },
    onConfirmDeletion() {
      this.deleteData('Deleted complete', this.selected);
    },
    onPageChanged(page) {
      this.pagination.current = page;
      this.getData();
    },
    onUpdated() {
      this.getData('Updated');
    },
    async onSubmitClicked(form) {
      const data = {
        prmsName: form.prmsName,
        prmsOperations: JSON.stringify(form.prmsOperations),
      };

      this.errors = {};
      this.isSubmit = true;
      try {
        let resp = {};
        if (form.prmsId) {
          resp = await PermissionSvc.updatePermission(form.prmsId, data);
        } else {
          resp = await PermissionSvc.createPermission(data);
        }
        if (resp.data.status.error === 0) {
          await this.getData('Success');
          this.currentPermission = {};
          this.displayForm = false;
        } else {
          const errors = resp.data.status.message;
          if (typeof errors === 'object') {
            this.errors = resp.data.status.message;
            this.$toast.error('Error found');
          } else {
            this.$toast.error(resp.data.status.message);
          }
        }
        this.isSubmit = false;
      } catch (e) {
        this.$toast.error('Error When Submiting Data');
        console.error('error when submiting data', e);
        this.isSubmit = false;
      }
    },
    openAddForm() {
      this.currentPermission = {};
      this.displayForm = true;
    },
    openDelete(data) {
      this.displayDeletion = true;
      this.selected = data;
    },
    openEdit(data) {
      this.displayForm = true;
      this.currentPermission = { ...this._.find(this.data, (v) => v.prmsId === data.prmsId) };
    },
    doLogOut() {
      this.$toast.error('Please re-login');
      this.$store.dispatch('auth/logout');
      this.$router.replace({ name: 'Login' });
    },
  },
  created() {
    this.debouncedSearch = this._.debounce(() => {
      this.filter.prmsName = this.searchTerm.trim() || null;
      this.pagination.current = 1;
      this.getData();
    }, 400);
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>

</style>
